export default __webpack_public_path__ + "static/media/11-57.ff52063f.png";